import React from "react";
import { Flex, Text } from "rebass/styled-components";
import Heading from "../common/Heading";
import Icon from "../common/Icon";
import useTranslation from "next-translate/useTranslation";
import { GetDogProfileQueryResult } from "../../generated/graphql";

interface Props {
  dog: GetDogProfileQueryResult["data"]["dog"];
}

const About = ({ dog }: Props) => {
  const { t } = useTranslation("dogprofile");

  const updated = !![
    dog.spayedNeutered,
    dog.playsCats,
    dog.playsDogs,
    dog.playsChildren
  ].filter((item: boolean | undefined) => typeof item == "boolean").length;

  return (
    updated && (
      <Flex
        px={[2, 2, 0]}
        sx={{
          flexDirection: "column",
          mt: 3
        }}
      >
        <Heading>
          {t("aboutDog", {
            dog: dog.name
          })}
        </Heading>
        {typeof dog?.spayedNeutered == "boolean" && (
          <Flex
            mt={3}
            sx={{
              alignItems: "center"
            }}
          >
            <Flex
              sx={{
                backgroundColor: dog.spayedNeutered ? "#6DD400" : "#B31412",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Icon
                name={dog.spayedNeutered ? "check" : "x"}
                color="samoyedWhite"
              ></Icon>
            </Flex>

            <Text ml={1}>{t("neuteredSpayed")}</Text>
          </Flex>
        )}
        {typeof dog?.playsCats == "boolean" && (
          <Flex
            mt={2}
            sx={{
              alignItems: "center"
            }}
          >
            <Flex
              sx={{
                backgroundColor: dog.playsCats ? "#6DD400" : "#B31412",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Icon
                name={dog.playsCats ? "check" : "x"}
                color="samoyedWhite"
              ></Icon>
            </Flex>
            <Text ml={1}>{t("playsWithCats")}</Text>
          </Flex>
        )}
        {typeof dog?.playsDogs == "boolean" && (
          <Flex
            mt={2}
            sx={{
              alignItems: "center"
            }}
          >
            <Flex
              sx={{
                backgroundColor: dog.playsDogs ? "#6DD400" : "#B31412",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Icon
                name={dog.playsDogs ? "check" : "x"}
                color="samoyedWhite"
              ></Icon>
            </Flex>
            <Text ml={1}>{t("playsWithDogs")}</Text>
          </Flex>
        )}
        {typeof dog?.playsChildren == "boolean" && (
          <Flex
            mt={2}
            sx={{
              alignItems: "center"
            }}
          >
            <Flex
              sx={{
                backgroundColor: dog.playsChildren ? "#6DD400" : "#B31412",
                borderRadius: "50%",
                width: "24px",
                height: "24px",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Icon
                name={dog.playsChildren ? "check" : "x"}
                color="samoyedWhite"
              ></Icon>
            </Flex>
            <Text ml={1}>{t("playsWithChildren")}</Text>
          </Flex>
        )}
      </Flex>
    )
  );
};

export default About;
